import { render, staticRenderFns } from "./ComplaintDocumentList.vue?vue&type=template&id=37516e7f&"
import script from "./ComplaintDocumentList.vue?vue&type=script&lang=js&"
export * from "./ComplaintDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports